export const SORT_ATTRIBUTES = {
  employee_first_name: 'employee_first_name',
  employee_last_name: 'employee_last_name',
  incidence_type: 'incidence_type',
  legal_entity_name: 'legal_entity_name',
  incidence_effective_date: 'incidence_effective_date',
  incidence_status: 'incidence_status',
}

const COLUMNS = [
  {
    id: 'employee_first_name',
    attribute: SORT_ATTRIBUTES.employee_first_name,
  },
  {
    id: 'employee_last_name',
    attribute: SORT_ATTRIBUTES.employee_last_name,
  },
  {
    id: 'translated_name',
    attribute: SORT_ATTRIBUTES.incidence_type,
  },
  {
    id: 'legal_entity_name',
    attribute: SORT_ATTRIBUTES.legal_entity_name,
  },
  {
    id: 'starts_on',
    attribute: SORT_ATTRIBUTES.incidence_effective_date,
  },
  {
    id: 'translated_status',
    attribute: SORT_ATTRIBUTES.incidence_status,
  },
  {
    id: 'translated_payroll_integration_status',
    attribute: SORT_ATTRIBUTES.incidence_status,
  },
]

export default COLUMNS
